import * as t from './actionTypes';
// import type { WorkflowWebhook } from './types';

export const copyWorkflowWebhookRequest = (
  workflowWebhook,
  workflowWebhookName,
  onCopy /* : () => void */,
) => ({
  type: t.COPY_WORKFLOW_WEBHOOK_REQUEST,
  payload: {
    workflowWebhook,
    workflowWebhookName,
    onCopy,
  },
});

export const deleteWorkflowWebhooksRequest = (
  workflowWebhooks /* : WorkflowWebhook[] */,
  onDelete /* : () => void */,
) => ({
  type: t.DELETE_WORKFLOW_WEBHOOKS_REQUEST,
  payload: { workflowWebhooks, onDelete },
});
